import styled from 'styled-components';

import { Cropper } from 'react-cropper';

import animations from 'styles/animations';
import colors from 'styles/colors';

export const Container = styled.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 5;
`;

interface IContentProps {
  maxWidth?: number;
}

export const Content = styled.div.attrs({
  id: 'modalCropperContent',
})<IContentProps>`
  animation-delay: 0.1s;
  animation-duration: 0.3s;
  animation-fill-mode: backwards;
  animation-name: ${animations.appear};
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  background-color: ${colors.white900};
  border-radius: 0.375rem;
  max-height: 90%;
  max-width: ${props => (props.maxWidth ? props.maxWidth : 28)}rem;
  overflow-y: auto;
  padding: 2rem;
  position: relative;
  width: 100%;
  z-index: 6;
  &.hideCropperModal {
    animation-name: ${animations.disappear};
  }
`;

export const Title = styled.h5`
  color: ${colors.orange900};
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;

export const ContentPreview = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 1rem auto;
  position: relative;
  width: 100%;
`;

export const PreviewImage = styled(Cropper)`
  display: block;
  height: 100%;
  max-height: 25rem;
  width: 100%;
`;

export const Actions = styled.div`
  align-items: center;
  column-gap: 0.5rem;
  display: grid;
  grid-template-columns: 6.5rem 10rem 8rem;
  justify-content: flex-end;
  margin-top: 1rem;
`;
